<template>
    <div class="mainContent">
        <div class="moduleMain">
            <div class="moudleTitle">
                乐学魔方 <b style="font-size: 16px">新手入门带你玩转学习</b>
            </div>
            <el-row class="content" :gutter="20">
                <el-col :span="6" >
                    <img src="static/image/u12.png" alt="">
                </el-col>
                <el-col :span="6">
                    <img src="static/image/u17.png" alt="">

                </el-col>
                <el-col :span="6">
                    <p>
                        <img src="static/image/u13.png" alt="">
                    </p>
                    <p>
                        <img src="static/image/u16.png" alt="">

                    </p>

                </el-col>
                <el-col :span="6">
                    <p>
                        <img src="static/image/u14.png" alt="">

                    </p>
                    <p>
                        <img src="static/image/u15.png" alt="">

                    </p>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "image-template"
    }
</script>

<style scoped lang="less">
    .content {
        img {
            width: 100%;
            height: 327px;
        }
        p > img {
            height: 160px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/imageTemplate.vue